import { storeToRefs } from "pinia";

import type { Influencer } from "shared/resources";
import { useGlobalStore } from "shared/stores/global";
import { type Source } from "shared/types/mentions";
import { isMentionWithOutlet } from "shared/types/mentions/guards";

interface UseSidebarOnMentionCardOptions {
  emit?: (event: "contact-clicked", ...args: unknown[]) => void;
}

export function useSidebarOnMentionCard(
  options: UseSidebarOnMentionCardOptions
) {
  const { emit } = options;

  const globalStore = useGlobalStore();
  const { isStreem } = storeToRefs(globalStore);

  function handleOpenOutletSidebar(source: Source) {
    if (!isOutletEnabled(source)) return;
    emit?.("contact-clicked", source);
  }

  function handleOpenOutreachContactSidebar(influencer: Influencer) {
    if (!influencer) return;
    emit?.("contact-clicked", influencer);
  }

  function selectInfluencer(influencerName: string, influencers: Influencer[]) {
    return influencers?.find(
      (influencer) => influencer?.name === influencerName
    );
  }

  function isInfluencerEnabled(
    influencerName: string,
    influencers: Influencer[]
  ) {
    return Boolean(selectInfluencer(influencerName, influencers));
  }

  function isOutletEnabled(source: Source) {
    if (!isMentionWithOutlet(source)) return false;

    return (
      !isStreem.value &&
      source.outlet_status === "Active" &&
      !source.outlet_monitoring_only_flag
    );
  }

  return {
    handleOpenOutletSidebar,
    handleOpenOutreachContactSidebar,
    isInfluencerEnabled,
    isOutletEnabled,
    selectInfluencer,
  };
}

export default useSidebarOnMentionCard;
